/* ready */
$(function () {
	'use strict';

	$('.p-event-search__tab li').on('click', function () {
		let index = $('.p-event-search__tab li').index(this);

		$('.p-event-search__cont > div:eq(' + index + ')').show();
		$('.p-event-search__cont > div:eq(' + index + ')').siblings().hide();
	});

	let cmapH = $('.p-event-dtl__cmap__level').outerHeight();
	cmapH = cmapH - 20;

	$('.p-event-dtl__cmap__other > div').css('height', cmapH / 2);
});

/* scroll */
$(window).on('scroll', function () {
	// シェアボタン
	let deviceWidth = window.innerWidth;
	const sideBnr = $('.l-side');

	if (deviceWidth < 768) {
		if ($(this).scrollTop() > 700) {
			sideBnr.fadeIn();
		} else {
			sideBnr.fadeOut();
		}
	}
});